import { render, staticRenderFns } from "./mainContents.vue?vue&type=template&id=074edc65&"
import script from "./mainContents.vue?vue&type=script&lang=ts&"
export * from "./mainContents.vue?vue&type=script&lang=ts&"
import style0 from "./mainContents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports